<template>
  <div class="MR_roadCleanPup absolute_center"
    :class="{_boxBg_dark_secondLevel:styleType == 'typeDark',_boxBg_green_secondLevel:styleType == 'typeGreen', _boxBg_blue_secondLevel:styleType == 'typeBlue'}">
    <div class="selfClose_btn" @click="close"></div>
    <div class="_boxTitle">道路清洁</div>
    <div class="_yellowLine"></div>
    <div class="_innerBox">
      <div class="mem_main_box">
        <div class="public-form">
          <div class="public-form-left">
            <el-form :inline="true" class="secondLevel-form-inline">
              <el-form-item class="secondLevel-label" label="道路名：">
                <el-input class="secondLevel-input" v-model="params.roadName" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item class="secondLevel-label" label="道路等级：">
                <el-select class="secondLevel-select" v-model="params.type" placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="(item,i) in selectList" :key="i" :label="item.roadTypeName" :value="item.type"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="margin-left:10px" class="secondLevel-label">
                <a class="self_btn" @click="check_click">查询</a>
                <a class="self_btn" @click="reset_click">重置</a>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="table_box">
          <el-table :header-cell-class-name="getHeaderCellClass" :header-row-class-name="getHeadRowClass" :cell-class-name="getCellClass" :row-class-name="getRowClass" class="secondLevel_table"
            :data="tableData" @row-click="rowClick" id="secondLevel_table" style="width: 100%">
            <el-table-column align="center" type="index" width="100px" label="序号" prop="">
              <template #default="scope">
                {{scope.$index+1+(Number(pageNo)-1)*Number(pageSize?pageSize:50)}}
              </template>
            </el-table-column>
            <el-table-column align="center" label="道路名" prop="roadName">
              <template #default="scope">
                <span>{{scope.row.roadName?scope.row.roadName:"--"}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="道路等级" prop="roadTypeName" width="300px">
              <template #default="scope">
                <span>{{scope.row.roadTypeName?scope.row.roadTypeName:"--"}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="今日保湿次数" prop="moisturizeTimes" width="300px">
              <template #default="scope">
                <span>{{scope.row.moisturizeTimes?scope.row.moisturizeTimes:"--"}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="今日清扫次数" prop="cleanupTimes">
              <template #default="scope">
                <span>{{scope.row.cleanupTimes?scope.row.cleanupTimes:"--"}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="今日调度次数" prop="scheduleTimes">
              <template #default="scope">
                <span>{{scope.row.scheduleTimes?scope.row.scheduleTimes:"--"}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="环保车今日清洁里程（公里）" prop="cleanDistance">
              <template #default="scope">
                <span>{{scope.row.cleanDistance?scope.row.cleanDistance:"--"}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="secondLevel-pagination_box pagination" v-if="!pagination && tableData.length">
          <el-pagination :page-size="50" layout="total,prev, pager, next,jumper" :total="total" @current-change="handleCurrentChange" :current-page="pageNo" />
          <p>跳转</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  props: {},
  data() {
    //这里存放数据
    return {
      customerId: this.$store.state.customerId,
      params: {
        roadName: "",
        type: "",
      },
      pageNo: 1,
      pageSize: 50,
      tableData: [],
      total: 0,
      selectList: [],
    };
  },
  //计算属性 类似于data概念
  computed: {
    styleType() {
      return this.$store.state.styleType;
    },
    realStatus() {
      return function (status) {
        let returnStatus = "";
        switch (status) {
          case 0:
            returnStatus = "停止";
            break;
          case 1:
            returnStatus = "运行";
            break;
          case 2:
            returnStatus = "无数据";
            break;
          case 3:
            returnStatus = "在线";
            break;
          case 4:
            returnStatus = "离线";
            break;
        }
        return returnStatus;
      };
    },
    getHeaderCellClass() {
      return (obj) => {
        if (this.styleType == "typeDark") {
          return "thClass";
        } else if (this.styleType == "typeGreen") {
          return "thClass_green";
        }
      };
    },

    getHeadRowClass() {
      return (obj) => {
        if (this.styleType == "typeDark") {
          return "headTrClass";
        } else if (this.styleType == "typeGreen") {
          return "headTrClass_green";
        }
      };
    },

    getCellClass() {
      return (obj) => {
        if (this.styleType == "typeDark") {
          return "tdClass";
        } else if (this.styleType == "typeGreen") {
          return "tdClass_green";
        }
      };
    },

    getRowClass() {
      return (obj) => {
        if (this.styleType == "typeDark") {
          return "trClass";
        } else if (this.styleType == "typeGreen") {
          return "trClass_green";
        }
      };
    },
  },
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getData();
    this.getSelectData();
  },
  //方法集合
  methods: {
    close() {
      let that = this._.appContext.app;
      this.$popup.close(that);
    },
    check_click() {
      this.pageNo = 1;
      this.getData();
    },
    async getSelectData() {
      let roadType = CONFIG.requestName + this.$apiOpt.roadType;
      let paramsList = {
        customerId: this.customerId,
      };
      let data = await this.$apiUtils.get(roadType, paramsList);
      this.selectList = data;
    },
    async getData() {
      let paramsList = {
        customerId: this.customerId,
        type: this.params.type,
        roadName: this.params.roadName,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      let getDeviceInfos = CONFIG.requestName + this.$apiOpt.cleaninfoDetail;
      let data = await this.$apiUtils.get(getDeviceInfos, paramsList);
      this.tableData = data.records;
      this.total = data.total;
    },
    reset_click() {
      this.params = {
        roadName: "",
        type: "",
      };
      this.pageNo = 1;
      this.getData();
    },
    handleCurrentChange(val) {
      this.tableData = [];
      this.pageNo = val;
      this.getData();
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
.mem_main_box {
  height: 100%;
  position: relative;
  :deep(.public-form) {
    .public-form-left {
      .secondLevel-form-inline {
        .secondLevel-label {
          .el-form-item__label {
          }
        }
        .secondLevel-select {
          width: 218px;
          height: 40px;
          border: 1px solid #99f5ff;
          color: #99f5ff;
          background: #071127;
          font-size: 16px;
        }
      }
    }
  }
  .secondLevel-pagination {
    display: flex;
    // align-items: center;
    justify-content: flex-end;
  }
}
.status_span {
  position: relative;
  vertical-align: middle;
  &::before {
    content: "";
    display: inline-block;
    width: 10px;
    height: 10px;
    background: rgba(138, 144, 153, 1);
    border-radius: 50%;
    margin-right: 10px;
  }
}
.statusActive:before {
  content: "";
  display: inline-block;
  width: 10px;
  height: 10px;
  background: rgba(0, 255, 0, 1);
  border-radius: 50%;
}
</style>
<style lang="scss" scoped>
._boxBg_green_secondLevel {
  .mem_main_box {
    .top_msg_box {
      .important_follow_box {
        background: rgba(6, 56, 53, 0.7);
        border: 1px solid #05fffa;
        box-shadow: 6px 5px 14px 2px #05fbf6;
        border-radius: 15px;
        .important_inner {
          &::after {
            background: rgb(33, 177, 187);
          }
          .important_inner_name {
            .num {
            }
            .blueFont {
              color: #c8dde1;
            }
          }
        }
      }
    }
    .public-form {
      margin-top: 10px;
      .public-form-left {
        .secondLevel-form-inline {
          .secondLevel-label {
            .el-form-item__label {
            }
          }
          .secondLevel-select {
            width: 218px;
            height: 40px;
            border: 1px solid #99f5ff;
            color: #99f5ff;
            background: #071127;
            font-size: 16px;
          }
        }
      }
    }
    .secondLevel-pagination {
      display: flex;
      // align-items: center;
      justify-content: flex-end;
    }
  }
  .status_span {
    position: relative;
    vertical-align: middle;
    &::before {
      content: "";
      display: inline-block;
      width: 10px;
      height: 10px;
      background: rgba(138, 144, 153, 1);
      border-radius: 50%;
      margin-right: 10px;
    }
  }
  .statusActive:before {
    content: "";
    display: inline-block;
    width: 10px;
    height: 10px;
    background: rgba(0, 255, 0, 1);
    border-radius: 50%;
  }
}
</style>
<style lang="scss" scoped>
.MR_roadCleanPup {
  .secondLevel-label {
    .el-form-item__label {
      color: #99f5ff !important;
      font-size: 20px;
      padding: 0 8px 0 0;
    }
  }
  :deep(.table_box) {
    height: 630px !important;
    .secondLevel_table {
      border: 1px solid #84aaff40 !important;
      background: #01132d40 !important;
      pointer-events: all;
      height: 630px !important;
      .el-table__body-wrapper {
        overflow-y: auto;
        height: 90%;
      }
    }
    .thClass {
      background: #01122ba6 !important;
      border-bottom: 1px solid #cccccc28 !important;
    }

    .thClass > .cell {
      font-size: 22px;
      color: rgba(200, 216, 255, 1);
      text-align: center !important;
    }

    .tdClass {
      border-right: 1px solid #84aaff40 !important;
      border-bottom: 1px solid #84aaff40 !important;
      background: #01122b66 !important;
    }
    .tdClass > .cell {
      font-size: 22px !important;
      color: #afafaf !important;
      font-family: "fontNormal" !important;
      text-align: center !important;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .headTrClass {
      border: 1px solid rgba(132, 170, 255, 0.5) !important;
    }

    .thClass_green {
      background: rgba(0, 73, 76, 0.8) !important;
      border-bottom: 1px solid rgba(5, 255, 250, 0.2) !important;
    }

    .thClass_green > .cell {
      font-size: 22px;
      color: rgba(200, 216, 255, 1);
      text-align: center !important;
    }

    .tdClass_green {
      border-right: 1px solid rgba(5, 255, 250, 0.2) !important;
      border-bottom: 1px solid rgba(5, 255, 250, 0.2) !important;
      background: rgba(178, 254, 252, 0.2) !important;
    }
    .tdClass_green > .cell {
      font-size: 22px !important;
      color: #afafaf !important;
      font-family: "fontNormal" !important;
      text-align: center !important;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .headTrClass_green {
      border: 1px solid rgba(5, 255, 250, 1) !important;
    }
  }
}
</style>
<style >
/* 分页 */
.MR_roadCleanPup .secondLevel-pagination_box {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  /* margin: 30px 100px 0 0; */
  margin: 20px 0 0 0;
}
.MR_roadCleanPup .secondLevel-pagination_box p {
  font-size: 28px;
}
.MR_roadCleanPup
  .secondLevel-pagination_box
  .el-pagination
  .el-pagination__total {
  margin-right: 50px;
}
.MR_roadCleanPup .secondLevel-pagination_box .el-pagination {
  text-align: right;
  padding: 0 130px 0 0;
}
.MR_roadCleanPup .secondLevel-pagination_box .el-pagination button,
.MR_roadCleanPup .el-pagination span:not([class*="suffix"]) {
  font-size: 26px;
  width: 80px;
  height: 80px;
  line-height: 80px;
  color: #ffffff;
}
.MR_roadCleanPup .secondLevel-pagination_box .el-pager li,
.MR_roadCleanPup .secondLevel-pagination_box .el-pager li.btn-quicknext,
.MR_roadCleanPup .secondLevel-pagination_box .el-pager li.btn-quickprev {
  font-size: 26px;
  width: 80px;
  height: 80px;
  line-height: 80px;
  color: #ffffff;
  background: transparent;
}
.MR_roadCleanPup .secondLevel-pagination_box .el-pager li.active {
  color: #55abf9;
}
.MR_roadCleanPup .secondLevel-pagination_box .el-pagination .btn-next,
.MR_roadCleanPup .el-pagination .btn-prev,
.MR_roadCleanPup .el-pagination button:disabled {
  background: transparent;
  color: #ffffff;
}
.MR_roadCleanPup .secondLevel-pagination_box .el-pagination .btn-next .el-icon,
.MR_roadCleanPup .el-pagination .btn-prev .el-icon {
  font-size: 28px;
}
.MR_roadCleanPup .secondLevel-pagination_box .el-pagination__editor.el-input {
  width: 80px;
  height: 50px;
}
.MR_roadCleanPup
  .secondLevel-pagination_box
  .el-pagination__editor.el-input
  .el-input__inner {
  height: 36px;
  font-size: 22px;
  border: 1px solid #dcdfe6;
  background: transparent;
  color: #fff;
}
._boxBg_blue_secondLevel
  .el-select__popper
  .el-select-dropdown
  .el-scrollbar
  .el-select-dropdown__wrap
  .el-scrollbar__view
  .el-select-dropdown__item {
  color: #fff;
}
</style>